import { App, URLOpenListenerEvent } from '@capacitor/app';
import React, { useEffect } from 'react';
import { useHistory } from '../../hooks/useRouterCompat';
import { My } from '../My';


// https://capacitorjs.com/docs/guides/deep-links
const AppUrlListener: React.FC<any> = () => {
  let history = useHistory();

  useEffect(() => {
    const unsub = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      console.log("Triggered App.addListener('appUrlOpen'...)", event.url);
      const slug = event.url.split('.team').pop();

      if (slug) {
        if (My.isLoggedIn()) {
          history.push(slug);
        }
        else {
          window.location.href = slug;
        }
      }
      // If no match, do nothing - let regular routing
      // logic take over
    });
    return () => {
      // console.log("Removed App.addListener('appUrlOpen'...")
      // unsub?.remove();
    }
  }, []);

  return null;
};

export default AppUrlListener;